import cloudFlare from './cloudFlare';

export default cloudFlare;
